<template>
  <generic-modal :title="$t('charge to member account')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('member')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/gym_member/catalog"
              name_field="name"
              value_field="gym_member_id"
              @selected="gym_member_changed"
              ref="gym_member_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="tags has-addons mt-2" v-if="meta.balance">
            <span class="tag is-large">{{ $t("balance") }}</span>
            <span
              class="tag is-large"
              v-bind:class="{
                'is-info': meta.balance > 0,
                'is-danger': meta.balance < 0,
              }"
              >{{ format_currency(meta.balance) }}</span
            >
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('movement type')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/account/movement_type/catalog"
              name_field="name"
              value_field="movement_type_id"
              @selected="movement_type_changed"
              ref="movement_type_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("total") }}</label>
            <div class="tag is-primary is-large">
              {{ format_currency(input_data.total) }}
            </div>
          </div>
        </div>
      </div>
    </form>
    <div v-if="products_summary.length" class="mt-5">
      <h1 class="title is-5 mb-1">{{ $t("products") }}</h1>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("total") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products_summary">
            <td>{{ product.quantity }} x {{ product.name }}</td>
            <td>{{ format_currency(product.total) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-check"></i>
        </span>
        <span>{{ $t("charge to account") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { groupBy } from "lodash";

export default {
  name: "ChargeAccountModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      input_data: {},
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.account_id || !v.meta.movement_type_id || !v.input_data.total
      );
    },
    products_summary() {
      let v = this;
      if (v.input_data.products) {
        let grps = groupBy(v.input_data.products, (p) => {
          return p.product_id;
        });
        return Object.keys(grps).map((key) => {
          return {
            product_id: grps[key][0].product_id,
            name: grps[key][0].name,
            quantity: grps[key].length,
            total: grps[key].reduce((acc, product) => {
              return acc + Number(product.sale_price);
            }, 0),
          };
        });
      } else return [];
    },
  },
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(input_data) {
      let v = this;
      v.set_initial_state();
      v.input_data = input_data;
      v.$refs.generic_modal.show_modal();
    },
    // edit_modal(uuid) {
    //   let v = this;
    //   v.set_initial_state();

    //   get("/customer", { uuid: uuid })
    //     .then((customer) => {
    //       v.meta = customer;
    //       v.$refs.generic_modal.show_modal();
    //     })
    //     .catch((error) => {
    //       v.error = generate_error_message_text(error);
    //     });
    // },
    save() {
      let v = this;
      let data = JSON.parse(JSON.stringify(v.meta));
      data.products = v.input_data.products.map((p) => {
        return { i: p.product_id, p: p.sale_price };
      });
      data.payment = [
        { name: v.$t("account charge"), amount: v.input_data.total },
      ];
      // payment, products
      data.total = v.input_data.total;
      put("/gym_pos/sale/charge", data)
        .then((movement_id) => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.input_data = {};
      v.meta = {
        account_id: "",
        settings: {},
      };
      v.$refs.gym_member_dropdown.clear();
      v.$refs.movement_type_dropdown.clear();
      v.error = "";
      // v.uuid = "";
    },
    gym_member_changed(value) {
      // console.log(value);
      this.meta.account_id = value.account.account_id;
      this.meta.balance = value.account.balance;
    },
    movement_type_changed(value) {
      this.meta.movement_type_id = value.movement_type_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
